export const PREVIEW_POLL_PLACEHOLDER = {
  satisfactionTextFieldLabel: 'Deixe seu comentário',
  satisfactionTextFieldPlaceHolder: 'Ex. Gostei muito...',
  reservationTextFieldLabel: 'Digite aqui sua resposta',
  reservationTextFieldPlaceHolder: 'Digite aqui....',
}
